module.exports = __webpack_public_path__ + "static/spacex-logo-0baae20ce5a7de36388ee9ab35643345.png";